jQuery(document).ready(commonInit);

function commonInit(){
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').length !== 0) return false;
	
	setupMobileMenu();
	setupMegaMenus();
	setupColumns();
	setupFancyFocus();
	setupScrollTriggers();
	setupScrollDetect();
	scrollDetectFire();
	setupTooltips(); 
	setupPageSelect();
	setupWarningModal();
	setupCountdownTimer();
	setupSearch();
	
}

function setupMobileMenu(){
	
	jQuery("#mobile-nav").mmenu({
		"slidingSubmenus": false,
		"offCanvas": {
			"position": "top"
		}
	}, {
	
		classNames: {
			selected: "current-menu-item",
			fixedElements: {
				
				fixed: "mobile-sticky"
				
			}
		}
		
	});
	
	jQuery("#mobile-menu-button").on("click", function(){
		
		if(jQuery("html").hasClass("mm-opened")) {
			var api = jQuery('#mobile-nav').data('mmenu');
			api.close();
		}
		
	});
	
}

function setupMegaMenus() {
	
	jQuery("#main-nav ul.menu li.menu-item-has-children").each(function(){
		
		var menuItem = jQuery(this);
		var menuLink = jQuery("> a", menuItem);
		var menuType = menuLink.attr("data-layout");
		
		if(menuType && menuType != "standard") {
			
			var description = menuLink.attr("data-description");
			var image = menuLink.attr("data-image");
			var linkLabel = menuLink.attr("data-link-label");
			var linkURL = menuLink.attr("data-link-url");
			var linkTarget = menuLink.attr("data-link-target");
			
			var container = jQuery(".mega-menu .right", menuItem);
			
			if(menuType == "background-image") {
			
				container.append("<div class='content'><p>" + description + "</p><p><a class='plumb-button outline-button' target='" + linkTarget + "' href='" + linkURL + "'>" + linkLabel + "</a></p></div>");
				container.css("background-image", "url(" + image + ")");
				
			} else if(menuType == "image") {
				
				container.append("<div class='image'><img src='" + image + "' alt=''></div>");
				container.append("<div class='content'><p>" + description + "</p><p><a class='plumb-button outline-button' target='" + linkTarget + "' href='" + linkURL + "'>" + linkLabel + "</a></p></div>");
				
				
			}
			
		}
		
	});
	
	jQuery("#main-nav > div > ul > li.menu-item-has-children").on("click", function(e){
		
		e.preventDefault();
		e.stopPropagation();
		
		jQuery("#main-nav > div > ul > li.menu-item-has-children, #desktop-header ").removeClass("hover");
		jQuery(this).addClass("hover");
		
	});
	
	jQuery("#main-nav > div > ul > li.menu-item-has-children .mega-menu a").on("click", function(e){
		
		e.stopPropagation();
		
	});
	
	jQuery("html, .search-button").on("click", function(e){
	
		jQuery("#main-nav > div > ul > li.menu-item-has-children").removeClass("hover");
		
	});
	
}

function setupColumns(){
	
	jQuery('.wp-block-columns').each(function(){
		
		var current = jQuery(this);
		var columnCount = jQuery('> *', current).length;
		
		current.addClass('has-'+columnCount+'-columns');
		
	});
	
}

//usage: var first = getUrlVars()['id'];
function getUrlVars(){
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}
window.getUrlVars = getUrlVars;

function setCookie(cname, cvalue, exdays){
	 
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    
}
window.setCookie = setCookie;

function getCookie(cname){
	
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    
    for(var i = 0; i <ca.length; i++){
        var c = ca[i];
        while (c.charAt(0) == ' '){
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
     
    return ""; 
    
}
window.getCookie = getCookie;

function setupFancyFocus(){	
	var formElements = jQuery('input, textarea');
	formElements.on('focus', function(){
		jQuery(this).closest(".gfield, .mobile-search-form").addClass('focus');
	});
	formElements.on('blur', function(){
		var listItem = jQuery(this);
		if (!listItem.val()) 
		{
			listItem.closest(".gfield, .mobile-search-form").removeClass('focus');
		}
		
	});
}
function setupScrollTriggers(){

	const elements = document.querySelectorAll('.scroll-alert:not(.set-up)');
	
	if ('IntersectionObserver' in window) {
	
		const options = {
			root: null,
			rootMargin: '0px 0px -10% 0px',
			threshold: 0
		};
		
		var observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if(entry.isIntersecting) {
					entry.target.classList.add('active');
				}
			});
		}, options);
		
		elements.forEach(element => {
			element.classList.add('set-up');
			observer.observe(element);
		});
		
	} else {
		
		for(var i=0; i<elements.length; i++) {
			elements[i].classList.add('set-up');
			elements[i].classList.add('active');	
		}
		
	}

}

function setupScrollDetect(){
	
	jQuery(window).on('scroll', scrollDetectFire);
	
}

function scrollDetectFire() {
	
	var offset = jQuery(window).scrollTop();
	var html = jQuery('html');
	 
	if(offset > 50) {
		html.addClass('not-top');
	} else {
		html.removeClass('not-top');
	}
	
}

function setupTooltips(){
	tippy('.tooltip', {
	  theme: 'midnight',
	  animation: 'slide-in',
	});
}

function setupPageSelect() {
	
	jQuery("select.change-page").on("change", function(){
		
		var url = jQuery(this).val();
		
		if(url) {
			window.location = url;
		}
		
	});
	
}


function setupWarningModal() {
	
	setTimeout(function(){
		
		if(jQuery('body').hasClass('sensitive-content')){
			jQuery('div[data-remodal-id="content-warning"]').remodal().open();
		}
	}, 100);
	
	jQuery('.content-warning-close').on("click", function(){
		
		jQuery("body").removeClass("sensitive-content");
		
	});
}

function setupCountdownTimer(){
	// Get the target date and time from the data attribute
		var targetDateTime = new Date(jQuery("#countdown").data("countdown"));
	
		// Update the countdown every second
		var countdownInterval = setInterval(function(){
			alertCounter(countdownInterval, targetDateTime);
		}, 1000);

		alertCounter(countdownInterval, targetDateTime);
	
		
}

function alertCounter(countdownInterval, targetDateTime){
	var now = new Date();
	
	  // Calculate the remaining time
	  var timeDiff = targetDateTime - now;
	  var days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
	  var hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	  var minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
	
	  // Format the countdown as DD:HH:MM
	  var formattedCountdown = padNumber(days) + "D | " + padNumber(hours) + "H | " + padNumber(minutes) + "M";
	
	  // Update the HTML element with the formatted countdown
	  jQuery("#countdown").text(formattedCountdown);
	  
	  console.log(timeDiff);
	
	  // Check if the countdown has reached zero
	  if (timeDiff <= 0) {
		clearInterval(countdownInterval);
		jQuery("body").removeClass("alert-banner-active");
		jQuery("#alert-banner").remove();
	  }else {
		jQuery("#alert-banner").addClass("show");
	  }
}

// Function to pad single-digit numbers with a leading zero
function padNumber(num) {
  return num < 10 ? "0" + num : num;
}

function setupSearch() {
	
	jQuery('header .search-button').on('click', function(e){
		
		var html = jQuery('html');
		var searchButton = jQuery(this);
		var isHeader = searchButton.parents('header').length;
		
		if(!html.hasClass('search-open')) {
		
			e.preventDefault();
			
			if(isHeader) {
				html.addClass('search-open-header search-open');
				jQuery('#search-header-desktop').focus();
			} else {
				html.addClass('search-open-footer search-open');
				jQuery('#search-footer').focus();
			}
			
		}
		
	});
	
	jQuery('.search-container form').on('click', function(e){
				
		e.stopPropagation();
		
	});
	
	jQuery('html, #main-nav > div > ul > li.menu-item-has-children').on('click', function(e){
		jQuery('html').removeClass('search-open-header search-open-footer search-open');
	});
	
	jQuery('.mobile-search-button').on('click', function(e){
		
		var html = jQuery('html');
		var searchButton = jQuery(this);
		
		html.addClass('mobile-search-open');
		
		
		
	});
	
	jQuery('.mobile-search-container form').on('click', function(e){
				
		e.stopPropagation();
		
	});
	jQuery('.search-close').on('click', function(e){
		jQuery('html').removeClass('mobile-search-open');
	});
	
	
	
}

